import { useMemo } from "react";

// Advisory only — the hard rule is the server-side >=12-char policy. This never
// blocks or replaces that; it just guides the user toward a stronger password.
function score(pw) {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 12) s += 2;
  else if (pw.length >= 8) s += 1;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s += 1;
  if (/\d/.test(pw)) s += 1;
  if (/[^A-Za-z0-9]/.test(pw)) s += 1;
  return s; // 0..5
}

const LEVELS = [
  { label: "Weak", color: "#dc2626", bars: 1 },
  { label: "Fair", color: "#d97706", bars: 2 },
  { label: "Strong", color: "#16a34a", bars: 3 },
];

export function PasswordStrength({ value }) {
  const level = useMemo(() => {
    const s = score(value);
    if (!value) return null;
    if (s <= 2) return LEVELS[0];
    if (s <= 3) return LEVELS[1];
    return LEVELS[2];
  }, [value]);

  if (!level) return null;

  return (
    <div className="mt-1.5" data-testid="password-strength">
      <div className="flex gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="h-1 flex-1 rounded-full transition-colors"
            style={{ backgroundColor: i < level.bars ? level.color : "rgba(120,120,120,0.2)" }}
          />
        ))}
      </div>
      <p className="mt-1 text-xs" style={{ color: level.color }} data-testid="password-strength-label">
        {level.label} password
      </p>
    </div>
  );
}
